import React from 'react';
import PropTypes from 'prop-types';
import { withRenderHandler } from '../../../../common/HOC';
import StatisticsChartsList from '../../../../components/statistics/StatisticsChartsList';

const Statistics = ({ statisticsMeta }) => (
  <StatisticsChartsList data={statisticsMeta} />
);

Statistics.propTypes = {
  statisticsMeta: PropTypes.array.isRequired,
};

export default withRenderHandler({
  Component: Statistics,
});



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/routes/Statistics/StatisticsPage/Statistics/Statistics.js